export function isImageDocumentType(filename: string): boolean {
  return ['jpg', 'jpeg', 'png', 'gif', 'webp'].some((ext) => filename.toLowerCase().endsWith(ext));
}

export function isIFCDocumentType(filename: string): boolean {
  return filename.toLowerCase().endsWith('.ifc');
}

/** Matches formats the AECOM DocumentViewer can render (true PDFs + Office formats converted server-side). */
export function isPDFDocumentType(filename: string): boolean {
  return ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx'].some((ext) =>
    filename.toLowerCase().endsWith(ext),
  );
}

export function isHTMLDocumentType(filename: string): boolean {
  return ['html', 'htm'].some((ext) => filename.toLowerCase().endsWith(ext));
}

export function isValidDocumentType(filename: string): boolean {
  return (
    isImageDocumentType(filename) ||
    isIFCDocumentType(filename) ||
    isPDFDocumentType(filename) ||
    isHTMLDocumentType(filename)
  );
}

const OFFICE_EXTENSIONS = ['.doc', '.docx', '.ppt', '.pptx', '.xls', '.xlsx', '.xlsm'];

/**
 * Force DocumentViewer to the correct renderer for server-converted Office
 * types. The backend serves a PDF through `readUrl`, but the original filename
 * would cause auto-detection to pick the wrong renderer.
 */
export function resolveViewerFileType(filename: string): string | undefined {
  const lower = filename.toLowerCase();
  if (OFFICE_EXTENSIONS.some((ext) => lower.endsWith(ext))) return 'pdf';
  return undefined;
}
